<template>
  <card>
    <template #header>
      <card-header>{{ $t("homes.projectStatus") }}
        <template v-if="showMore" #action>
          <el-link type="primary" :underline="false" @click="tomore">
            {{ $t("global.more") }}
            <i class="el-icon-arrow-right" style="color:#999999;" />
          </el-link>
        </template>
      </card-header>
    </template>
    <stage-ratio :key="key" :stage-item-data="stageItemData" 
      @projectClick="projectClick" 
      @patentCountClick="patentCountClick"
      @patentClick="patentClick"
      ref="stageRatio"  />
  </card>
</template>

<script>
import { projectPhaseStatus } from '@/api/homes'

export default {
  name: '',
  components: {},
  mixins: [],
  props: {
    autoLoad:{
      type:Boolean,
      default:true
    }
  },
  data() {
    return {
      key:0,
      showMore:false,
      stageItemData: [],
      currentCompanyId:null
    }
  },
  computed: {
    lang() {
      return this.$store.state.app.language;
    },
  },
  watch: {
    lang(){
      this.loadData(this.currentCompanyId);
    }
  },
  created() {
    this.loadData(this.currentCompanyId);
  },
  mounted() {},
  destroyed() {},
  methods: {
    loadData(companyId) {
      // if (companyId !== undefined && companyId != null && companyId !== "") {
      //   this.currentCompanyId = companyId;
      // }

      this.currentCompanyId = companyId;

      projectPhaseStatus(this.currentCompanyId).then(resp => {
        const data = resp.data;
        this.stageItemData = [];
        if(!data){
          return
        }

        if(data.projectCount > 5){
          this.showMore = true;
        }

        for (let i = 0; i < data.data.length; i++) {
          let project = {};
          project.id = data.data[i].projectId;
          project.name = data.data[i].projectName;
          project.totalCount = data.data[i].phaseCount;
          project.children = [];

          let noPatentIndex = -1//没有专利的阶段序号
          let noPatentCount = 0//没有专利的阶段数量
          for (let p = 0; p < data.data[i].phaseList.length; p++) {
            let child = 
            {            
              id:data.data[i].phaseList[p].phaseId,
              name: data.data[i].phaseList[p].phaseName,
              count: data.data[i].phaseList[p].patentCount,
              iconNameArray: data.data[i].phaseList[p].patentAppNo 
                ? data.data[i].phaseList[p].patentAppNo : [],
              isCurStep: data.data[i].phaseList[p].isCurrent == "0"
            }

            if(child.count > 0 || child.isCurStep){
              //如果该阶段有专利或者是当前执行阶段，则重新清空序号
              noPatentIndex = -1
              noPatentCount = 0
            }
            else {
              if(noPatentIndex == -1){
                //如果该阶段没有专利，并且没有记录序号时，记录当前序号
                noPatentIndex = p
              }
              noPatentCount++
            }
            if(p == data.data[i].phaseList.length - 1){
              //最后一个阶段，如果有专利或者是当前执行阶段，则正常显示，否则作为最后未完成阶段
              child.type = (child.count > 0 || child.isCurStep) ? undefined : 'LastUnFinshed' 
              if(child.type){
                noPatentCount--//减去最后一个阶段
              }
            }
            project.children.push(child);
          }

          if(project.children.length >= 2 && project.children.length - noPatentCount < 2){
            //如果减去到最后一个阶段之前的无专利项后，小于两个阶段，则减少减去的数量
            let noPatentCountNew = project.children.length - 2//数量减少n个
            noPatentIndex += noPatentCount - noPatentCountNew//序号后移n位
            noPatentCount = noPatentCountNew
          }
          if(noPatentIndex > -1 && noPatentCount > 0){
            //删除在最后一个阶段之前的没有专利的阶段
            project.children.splice(noPatentIndex, noPatentCount)
          }

          this.stageItemData.push(project);
        }

        //this.$refs.stageRatio.loadData()
        this.key ++
      });
    },

    projectClick(projectId){
      this.$router.push({path:'/projectManagement/projectProcessExcute',query:{id:projectId}})
    },
    patentCountClick(projectId,phaseId,projectName){
      this.$router.push({path:'/patentManagement/patentListView',query:{projectId,phaseId,projectName, mainType: 2}})
    },
    patentClick(patentId){
      this.$router.push({path:'/patentManagement/patentView',query:{id:patentId}})
    },
    tomore(){
      //this.$router.push({path:'/projectManagement/projectListView'})
      this.$emit("more")
    }
  }
}
</script>
